(() => {
  'use strict';
  const root = document.querySelector('[data-partner-cart]');
  if (!root || window.__oazarPartnerCartReady) return;
  window.__oazarPartnerCartReady = true;
  const drawer = root.querySelector('[data-partner-cart-drawer]');
  const itemsNode = root.querySelector('[data-partner-cart-items]');
  const foot = root.querySelector('[data-partner-cart-foot]');
  const total = root.querySelector('[data-partner-cart-total]');
  const titleCount = root.querySelector('[data-partner-cart-title-count]');
  const checkoutLink = root.querySelector('.partner-cart__checkout');
  const shippingNote = root.querySelector('[data-partner-cart-shipping-note]');
  const routeRoot = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format((Number(cents) || 0) / 100);
  let lastFocus = null;
  let loading = false;

  function close() {
    root.classList.remove('is-open');
    drawer.inert = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.removeProperty('overflow');
    if (lastFocus?.isConnected) lastFocus.focus({ preventScroll: true });
  }
  function reveal() {
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawer.focus({ preventScroll: true });
  }
  function element(tag, className, value) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (value != null) node.textContent = String(value);
    return node;
  }
  function line(item) {
    const article = element('article', 'partner-cart__line');
    const media = element('a');
    media.href = item.url || '#';
    if (item.image) {
      const image = element('img');
      image.src = item.image;
      image.alt = item.product_title || '';
      image.loading = 'lazy';
      media.append(image);
    }
    article.append(media);
    const info = element('div');
    const link = element('a', '', item.product_title || item.title);
    link.href = item.url || '#';
    info.append(link);
    if (item.variant_title && item.variant_title !== 'Default Title') info.append(element('p', '', item.variant_title));
    if (item.properties?.['Pseudo sur le t-shirt']) info.append(element('p', 'partner-cart__pseudo', `Pseudo : ${item.properties['Pseudo sur le t-shirt']}`));
    if (item.properties?.['Retrait PGW'] === 'Oui') info.append(element('p', 'partner-cart__pickup', 'Retrait à la PGW'));
    const controls = element('div', 'partner-cart__line-bottom');
    const qty = element('div', 'partner-cart__quantity');
    const minus = element('button', '', '−');
    minus.type = 'button'; minus.setAttribute('aria-label', 'Diminuer la quantité');
    minus.dataset.cartKey = item.key; minus.dataset.cartQty = String(item.quantity - 1);
    const plus = element('button', '', '+');
    plus.type = 'button'; plus.setAttribute('aria-label', 'Augmenter la quantité');
    plus.dataset.cartKey = item.key; plus.dataset.cartQty = String(item.quantity + 1);
    qty.append(minus, element('span', '', item.quantity), plus);
    controls.append(qty, element('strong', '', money(item.final_line_price)));
    info.append(controls);
    const remove = element('button', 'partner-cart__remove', 'Supprimer');
    remove.type = 'button'; remove.dataset.cartKey = item.key; remove.dataset.cartQty = '0';
    info.append(remove);
    article.append(info);
    return article;
  }
  function render(cart) {
    itemsNode.replaceChildren();
    titleCount.textContent = `(${cart.item_count})`;
    document.querySelectorAll('[data-partner-cart-count]').forEach(node => node.textContent = cart.item_count);
    foot.hidden = cart.item_count === 0;
    total.textContent = money(cart.total_price);
    const pickup = cart.items.length > 0 && cart.items.every(item => item.properties?.['Retrait PGW'] === 'Oui');
    const code = String(root.dataset.pgwDiscountCode || '').trim();
    if (shippingNote) shippingNote.textContent = pickup
      ? (code ? 'Retrait PGW : livraison offerte au paiement.' : 'Retrait PGW demandé. Frais confirmés au paiement.')
      : 'Frais de livraison calculés à l’étape suivante.';
    if (checkoutLink) {
      checkoutLink.href = pickup && code
        ? `${routeRoot}discount/${encodeURIComponent(encodeURIComponent(code))}?redirect=%2Fcheckout`
        : `${routeRoot}checkout`;
    }
    if (!cart.items.length) {
      const empty = element('div', 'partner-cart__empty');
      empty.append(element('strong', '', 'Votre panier est vide'), element('p', '', 'Découvrez les créations de cette collection.'));
      itemsNode.append(empty);
    } else cart.items.forEach(item => itemsNode.append(line(item)));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    return cart;
  }
  async function refresh(open = false) {
    const response = await fetch(`${routeRoot}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Impossible de charger le panier.');
    const cart = render(await response.json());
    if (open) reveal();
    return cart;
  }
  async function add(id, quantity = 1, properties = {}) {
    const response = await fetch(`${routeRoot}cart/add.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Math.max(1, Number(quantity) || 1), properties }] })
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Impossible d’ajouter ce produit.');
    await refresh(true);
    return result;
  }
  async function change(key, quantity) {
    if (loading) return;
    loading = true;
    try {
      const response = await fetch(`${routeRoot}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Impossible de modifier le panier.');
      await refresh(false);
    } catch (error) { window.alert(error.message); }
    finally { loading = false; }
  }
  document.querySelectorAll('[data-partner-cart-open]').forEach(button => button.addEventListener('click', () => refresh(true).catch(error => window.alert(error.message))));
  root.querySelectorAll('[data-partner-cart-close]').forEach(button => button.addEventListener('click', close));
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-key]');
    if (button) change(button.dataset.cartKey, button.dataset.cartQty);
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && root.classList.contains('is-open')) close(); });
  window.OazarCart = Object.assign(window.OazarCart || {}, { refresh, open: () => refresh(true), close, add });
  document.addEventListener('cart:refresh', event => refresh(Boolean(event.detail?.open)).catch(() => {}));
  refresh(false).catch(() => {});
})();
